import { resolveAnalyticsBook } from '@/features/chart/lib/series-sources/analytics-book'
import {
  resolveBaseCurrency,
  resolveQuoteCurrency,
} from '@/features/order/order-form/lib/instrument-resolution'
import type { SeriesFetchContext } from '@/lib/tradingview/datafeeds/series-sources'
import { queryClient } from '@/provider/query-provider'
import { fetchAmberdataAnalyticRangeList } from '@/service/amberdata/analytics.api'
import { surfaceCurrenciesQueryOptions } from '@/service/amberdata/analytics.hook'
import { buildAmberdataAnalyticsRequest } from '@/service/amberdata/analytics.types'

type AmberdataAnalyticsType = Parameters<typeof buildAmberdataAnalyticsRequest>[0]['analyticsType']

/**
 * Shared range fetch for own-fetch Amberdata options series (PCR, skew).
 * Resolves to undefined when the exchange has no matching book.
 */
export async function fetchAmberdataSeriesList(
  ctx: SeriesFetchContext,
  analyticsType: AmberdataAnalyticsType,
  signal: AbortSignal
) {
  const base = resolveBaseCurrency([], ctx.symbol, null)
  const quote = resolveQuoteCurrency([], ctx.symbol, null)
  const books = await queryClient.fetchQuery(surfaceCurrenciesQueryOptions)
  signal.throwIfAborted()
  const book = resolveAnalyticsBook(books, ctx.exchange, base, quote)
  if (!book) return undefined

  return fetchAmberdataAnalyticRangeList(
    {
      ...buildAmberdataAnalyticsRequest({
        exchange: ctx.exchange,
        symbol: book,
        analyticsType,
      }),
      from: String(ctx.fromSec * 1000),
      to: String(ctx.toSec * 1000),
    },
    signal
  )
}
